/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Png_Jpg_Webp_Max_10mb_EachInputs */

const en_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Max 10MB each`)
};

const es_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Max 10MB c/u`)
};

const fr_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Max 10 Mo chacun`)
};

const de_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Max 10MB jeweils`)
};

const ja_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · 各最大10MB`)
};

const zh_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · 每张最大 10MB`)
};

const ar_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · بحد أقصى 10 ميغابايت لكل صورة`)
};

const id_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Maks 10MB masing-masing`)
};

const it_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Max 10MB ciascuno`)
};

const ru_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Максимум 10 МБ каждое`)
};

const pt_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · Max 10MB cada`)
};

const ko_png_jpg_webp_max_10mb_each = /** @type {(inputs: Png_Jpg_Webp_Max_10mb_EachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG, WEBP · 장당 최대 10MB`)
};

/**
* | output |
* | --- |
* | "PNG, JPG, WEBP · Max 10MB each" |
*
* @param {Png_Jpg_Webp_Max_10mb_EachInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const png_jpg_webp_max_10mb_each = /** @type {((inputs?: Png_Jpg_Webp_Max_10mb_EachInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Png_Jpg_Webp_Max_10mb_EachInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "es") return es_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "fr") return fr_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "de") return de_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "ja") return ja_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "zh") return zh_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "ar") return ar_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "id") return id_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "it") return it_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "ru") return ru_png_jpg_webp_max_10mb_each(inputs)
	if (locale === "pt") return pt_png_jpg_webp_max_10mb_each(inputs)
	return ko_png_jpg_webp_max_10mb_each(inputs)
});